<template>
  <h2>
    Islykill return URL
  </h2>
</template>

<script>
    export default {
        name: 'IslykillMock'
    }
</script>